import { IActionOrTriggerListPageParams } from "@app/static";
import { INameIDData } from "../common/INameIDData.intf";
import { IPermissionData } from "../permission";
import { createMergeToDefaultData, mergeDataWith } from "../utils/mergeToDefaultData";
import { ITriggerGroup } from "./ITriggerGroup.intf";

export interface ITriggerOn{
    id:string
}
export interface ITriggerOff{
    id:string
}
export interface ITriggerJavaData {
    on?:ITriggerOn[]
    off?:ITriggerOff[]
}
export interface ITriggerShellData {
}

export interface ITriggerData<T extends ITriggerShellData, U extends ITriggerJavaData> extends INameIDData<T, U>{
    // type:string
    // i18n?:II18nValueConf
    permissions?:IPermissionData[]
    javaData:U
}


export interface ITriggerUtils<T extends ITriggerData<ITriggerShellData, ITriggerJavaData>>{
    type:string
    mergeDataToDefultData:(data:Partial<T>)=>T
    createDefultData:()=>T,
    create:(triggerGroup:ITriggerGroup, data?:Partial<T>)=>void
    update:(trigger:T, data?:Partial<T>)=>void
    UI:(data:T)=>React.ReactNode
    init:()=>void
    //点击更改按钮后调用不是page页面的时候需要，例如更改返回首页.
    onClickChange?:(data:{query:IActionOrTriggerListPageParams}, ...rest:any[])=>void
}

export interface ITriggerUtilsMap{
    [key:string]:ITriggerUtils<any>
}

export const TriggerUtilsMap:ITriggerUtilsMap = {}

export function registerTriggerUtils(key:string,utils:ITriggerUtils<any>){
    if(key in TriggerUtilsMap){
        throw new Error(`TriggerUtilsMap already has key: ${key}`)
    }
    TriggerUtilsMap[key] = utils
}

export function getTriggerUtils<T extends ITriggerData<ITriggerShellData, ITriggerJavaData>>(key:string):ITriggerUtils<T>{
    return TriggerUtilsMap[key]
}

export function createTriggerUtils<T extends ITriggerData<ITriggerShellData, ITriggerJavaData>>(type:string, init:()=>void, createDefultData:()=>T, UI:(data:T)=>React.ReactNode):ITriggerUtils<T>{
    const res = {
        type,
        mergeDataToDefultData:createMergeToDefaultData(createDefultData),
        createDefultData,
        create:(triggerGroup:ITriggerGroup, data?:Partial<T>)=>{
            const trigger = createDefultData()
            triggerGroup.list.push(trigger)
        },
        update:(trigger:T, data?:Partial<T>)=>{
            mergeDataWith(trigger, data)
        },
        UI,
        init,
    }
    registerTriggerUtils(type,res)
    return res
}   
